import { type AddressConstructorData } from '@webapp/core/entities/internal/Address'
import {
  AddressTypes,
  type AddressTypeEnum,
} from '@webapp/core/entities/internal/Address/AddressTypes'
import { type PrimaryCategoryConfigDetailConstructor } from '@webapp/platform/organization-management/entities/PrimaryCategoryConfigDetail'
import {
  type AddressDetailApiModel,
  type PrimaryCategoryConfigDetailApiModel,
} from '../api-models/PrimaryCategoryConfigDetailApiModel'

const mapAddressDetailApiModel = (
  apiModel: AddressDetailApiModel,
  primaryCategoryId: number,
  addressType: AddressTypeEnum
): AddressConstructorData => ({
  id: apiModel.id,
  name: apiModel.name,
  addressLineOne: apiModel.addressLineOne,
  addressLineTwo: '',
  city: apiModel.city,
  stateProvince: apiModel.state_province,
  postalCode: apiModel.postalCode,
  country: apiModel.country,
  isActive: true, // Assumed active since it's the primary category's address
  addressType,
  primaryCategory: primaryCategoryId,
})

export const mapPrimaryCategoryConfigDetailApiModel = (
  apiModel: PrimaryCategoryConfigDetailApiModel
): PrimaryCategoryConfigDetailConstructor => ({
  id: apiModel.id,
  name: apiModel.name,
  email: apiModel.email,
  phoneOne: apiModel.phoneOne,
  fax: apiModel.fax,
  url: apiModel.url,
  externalId: apiModel.external_id,
  active: apiModel.active,
  headquarter: apiModel.headquarter,
  editable: apiModel.editable,
  logo: apiModel.logo,
  locationTimezone: apiModel.locationTimezone,
  language: apiModel.language,
  currency: apiModel.currency.id,
  primaryBillingAddress: mapAddressDetailApiModel(
    apiModel.primary_billing_address,
    apiModel.id,
    AddressTypes.BILLING
  ),
  primaryShippingAddress: mapAddressDetailApiModel(
    apiModel.primary_shipping_address,
    apiModel.id,
    AddressTypes.SHIPPING
  ),
  shippingAddresses: apiModel.shipping_addresses.map((addr) =>
    mapAddressDetailApiModel(addr, apiModel.id, AddressTypes.SHIPPING)
  ),
})
